module.exports = __webpack_public_path__ + "media/images/logo-og-da566f791391805f1c38345dab53c684.jpg";